import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROLES } from '../config/roles';
import './SigninForm.css';

const SESSION_LENGTH = 60 * 60 * 1000; // 1 hour – same as the backend token

// Every auth key used anywhere in the app (old and new)
const AUTH_KEYS = ['token', 'accessToken', 'role', 'loginTime', 'expiry'];
const clearAuth = () => AUTH_KEYS.forEach((key) => localStorage.removeItem(key));

const Signin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Auto logout after 1 hour
    const checkAutoLogout = () => {
      const loginTime = localStorage.getItem('loginTime');
      if (loginTime && Date.now() - parseInt(loginTime, 10) > SESSION_LENGTH) {
        clearAuth();
        navigate('/signin');
      }
    };

    const autoLogoutInterval = setInterval(checkAutoLogout, 60000);
    return () => clearInterval(autoLogoutInterval);
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch('https://backend.ems.uk.hiradentallab.com/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      if (response.ok) {
        const data = await response.json();

        // The login API may call the token "token", "accessToken" or "jwt"
        const authToken = data.token || data.accessToken || data.jwt;
        if (!authToken) {
          console.error('Login response has no token field:', data);
          alert('Login succeeded but no token was returned by the server.');
          return;
        }

        // 1) Remove anything left over from an older login
        //    (a stale "expiry" was making axiosInstance log you out instantly)
        clearAuth();

        // 2) Save the new session under BOTH keys so every part of the app finds it
        const now = Date.now();
        localStorage.setItem('token', authToken);
        localStorage.setItem('accessToken', authToken);
        localStorage.setItem('role', data.role);
        localStorage.setItem('loginTime', now.toString());
        localStorage.setItem('expiry', (now + SESSION_LENGTH).toString());

        console.log('Login Success - Role:', data.role);

        // Role-based redirect
        if (data.role === ROLES.STAFF) {
          navigate('/current-atd');
        } else {
          navigate('/dashboard');
        }
      } else {
        const errorData = await response.json();
        alert(errorData.message);
      }
    } catch (error) {
      console.error('Error during login:', error);
      alert('An error occurred. Please try again.');
    }
  };

  return (
    <div className="signin-auth-page-container">
      <form className="signin-auth-form-container" onSubmit={handleSubmit}>
        <h2 className="signin-auth-form-title">Sign In</h2>
        <div className="signin-auth-input-group">
          <label className="signin-auth-label">Username:</label>
          <input
            className="signin-auth-input"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="signin-auth-input-group">
          <label className="signin-auth-label">Password:</label>
          <input
            className="signin-auth-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button className="signin-auth-submit-button" type="submit">
          Sign In
        </button>
      </form>
    </div>
  );
};

export default Signin;